import Illustration from "@/components/atoms/Illustration/Image"
import { StaticImageData } from "next/image"
import Link from "next/link"
import React from "react"

export type EventCardProps = {
  id: string
  imageSrc: string | StaticImageData
  title: string
  subtitle: string
  updatedAt: string
}

const EventCard: React.FC<EventCardProps> = ({ imageSrc, title, updatedAt, subtitle, id }) => {
  const href = `/story/${id}`
  const linkArea = `Checkout story: ${title}`
  return (
    <Link href={href} aria-label={linkArea}>
      <div className="mb-2 cursor-pointer overflow-hidden rounded-2xl">
        <Illustration
          src={imageSrc}
          alt={title}
          className="h-[220px] w-full rounded-2xl object-cover duration-500 hover:scale-105"
          height={220}
          width={220}
        />
      </div>
      <div className="space-y-2">
        <p className="text-xs text-gray-500">{updatedAt}</p>
        <p className="line-clamp-1 font-bold capitalize">{title}</p>
        {subtitle && <p className="line-clamp-2 text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>}
      </div>
    </Link>
  )
}

export default EventCard
